var _style, _rect, _defs, _rect2, _defs2, _line, _defs3, _path, _defs4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidelogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 960 1080",
    style: {
      enableBackground: "new 0 0 960 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#8DB6E1;}\n\t.st1{clip-path:url(#SVGID_00000026133218063745628630000005784914830150972824_);fill:#242F64;}\n\t.st2{clip-path:url(#SVGID_00000026133218063745628630000005784914830150972824_);fill:#0656A5;}\n\t.st3{clip-path:url(#SVGID_00000026133218063745628630000005784914830150972824_);fill:#FFFFFF;}\n\t.st4{fill:#0656A5;}\n\t.st5{clip-path:url(#SVGID_00000183227956269664515990000003342575194545220010_);fill:#F79A6F;}\n\t\n\t\t.st6{clip-path:url(#SVGID_00000183227956269664515990000003342575194545220010_);fill:none;stroke:#FFFFFF;stroke-width:6.5;stroke-linecap:round;}\n\t.st7{fill:none;stroke:#FFFFFF;stroke-width:6.5;stroke-linecap:round;}\n\t\n\t\t.st8{clip-path:url(#SVGID_00000183221400502236481220000008381365364780405684_);fill:none;stroke:#8DB6E1;stroke-width:10.92;stroke-miterlimit:10;}\n\t.st9{clip-path:url(#SVGID_00000183221400502236481220000008381365364780405684_);fill:#0656A5;}\n\t.st10{fill:none;stroke:#FFFFFF;stroke-width:1.092;stroke-miterlimit:10;}\n\t.st11{clip-path:url(#SVGID_00000152946384944940269320000003917749195452443789_);fill:#F79A6F;}\n\t.st12{clip-path:url(#SVGID_00000152946384944940269320000003917749195452443789_);fill:#242F64;}\n\t\n\t\t.st13{clip-path:url(#SVGID_00000152946384944940269320000003917749195452443789_);fill:none;stroke:#8DB6E1;stroke-width:10.92;stroke-miterlimit:10;}\n\t.st14{clip-path:url(#SVGID_00000152946384944940269320000003917749195452443789_);fill:#0656A5;}\n\t\n\t\t.st15{clip-path:url(#SVGID_00000152946384944940269320000003917749195452443789_);fill:none;stroke:#242F64;stroke-width:6.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st16{clip-path:url(#SVGID_00000152946384944940269320000003917749195452443789_);fill:#8DB6E1;}\n\t\n\t\t.st17{clip-path:url(#SVGID_00000152946384944940269320000003917749195452443789_);fill:none;stroke:#FFFFFF;stroke-width:6.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st18{clip-path:url(#SVGID_00000152946384944940269320000003917749195452443789_);fill:#FFFFFF;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 960,
    height: 1080
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 960,
    height: 1080
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000058559638278662385900000014771397226255254447_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000058559638278662385900000014771397226255254447_)",
      fill: "#242F64"
    },
    d: "M240,480 c132.5,0,240-107.5,240-240S372.5,0,240,0S0,107.5,0,240S107.5,480,240,480"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000058559638278662385900000014771397226255254447_)",
      fill: "#242F64"
    },
    d: "M720,960 c132.5,0,240-107.5,240-240S852.5,480,720,480S480,587.5,480,720S587.5,960,720,960"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000058559638278662385900000014771397226255254447_)",
      fill: "#0656A5"
    },
    d: "M720,240V0 c132.5,0,240,107.5,240,240H720z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000058559638278662385900000014771397226255254447_)",
      fill: "#0656A5"
    },
    d: "M960,480V240 c-132.5,0-240,107.5-240,240H960z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000058559638278662385900000014771397226255254447_)",
      fill: "#FFFFFF"
    },
    d: "M720,480V240 c-132.5,0-240,107.5-240,240H720z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000058559638278662385900000014771397226255254447_)",
      fill: "#242F64"
    },
    d: "M600,240 c66.3,0,120-53.7,120-120S666.3,0,600,0S480,53.7,480,120S533.7,240,600,240"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 480,
    className: "st4",
    width: 480,
    height: 480
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000001655104057300727300000002986820866603566776_",
    width: 960,
    height: 1080
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000019676939684349906680000012353686028168331956_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000001655104057300727300000002986820866603566776_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000019676939684349906680000012353686028168331956_)",
      fill: "#F79A6F"
    },
    d: "M375.7,608.6 c-42.9-42.1-106.4-19.3-135.7,14.3c-29.3-33.6-92.8-56.4-135.7-14.3C64,648.2,48.6,731.4,240,854.3v0c0,0,0,0,0,0c0,0,0,0,0,0v0 C431.4,731.4,416,648.2,375.7,608.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000019676939684349906680000012353686028168331956_)",
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 6.5,
      strokeLinecap: "round"
    },
    d: " M346.3,626.9c27.4,12.9,35.6,43.7,17.4,72.2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 345.4,
    y1: 725.4,
    x2: 331.5,
    y2: 741.4
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000096053055675416158540000014661339577624064444_",
    width: 960,
    height: 1080
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000158019366697734347920000017685454252006835346_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096053055675416158540000014661339577624064444_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000158019366697734347920000017685454252006835346_)",
      fill: "none",
      stroke: "#8DB6E1",
      strokeWidth: 10.92,
      strokeMiterlimit: 10
    },
    d: " M289,270.1c-11.7,1.9-77.6,14.5-105.1,45.7 M213,203.1c-0.5,11.9-4.8,78.8-32.3,110"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000158019366697734347920000017685454252006835346_)",
      fill: "#0656A5"
    },
    d: "M192.7,317.2 l-14.5-12.8c-2.3-2-5.8-1.8-7.9,0.5l-48.9,55.4c-0.1,0.1-0.1,0.1-0.2,0.2c-5.2,6.3-4.5,15.7,1.7,21.1c6.2,5.5,15.5,5,21.2-1 c0.1-0.1,0.1-0.1,0.2-0.2l48.9-55.4C195.3,322.8,195,319.3,192.7,317.2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M282.8,269.4l-67.5-59.6 M306.8,263.2L218.2,185 M327.8,254.3l-104.7-92.4 M341.4,238.9l-104.7-92.4  M355,223.5l-104.7-92.4 M368.6,208.1l-104.7-92.4 M375.1,186.3L285,106.8 M378.6,162l-69.9-61.7 M378.3,170.3l-86.9,98.4  M376.3,141.5L264.8,267.8 M363.7,124.7l-119,134.8 M348.3,111.1l-119,134.8 M330.3,100.4L218.4,227.2 M301.7,101.7L215.8,199"
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000058590859326199461350000012414155058274032528_",
    width: 960,
    height: 1080
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000150064085731402246060000006395437283489691035_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000058590859326199461350000012414155058274032528_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000150064085731402246060000006395437283489691035_)",
      fill: "#F79A6F"
    },
    d: "M161.2,254.7 c4.4-6,6.9-13.4,6.9-21.3c0-8-2.6-15.3-6.9-21.3c-5.3,5.6-8.6,13.1-8.6,21.3C152.7,241.6,155.9,249.1,161.2,254.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000150064085731402246060000006395437283489691035_)",
      fill: "#F79A6F"
    },
    d: "M153.6,204.2 c-6.1-4.5-13.6-7.2-21.8-7.2s-15.7,2.7-21.8,7.2c7.3,7.5,11.8,17.8,11.8,29.1c0,11.3-4.5,21.6-11.8,29.1c6.1,4.5,13.6,7.2,21.8,7.2 s15.7-2.7,21.8-7.2c-7.3-7.5-11.8-17.8-11.8-29.1C141.7,222,146.3,211.8,153.6,204.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000150064085731402246060000006395437283489691035_)",
      fill: "#F79A6F"
    },
    d: "M102.4,254.7 c5.3-5.6,8.6-13.1,8.6-21.3c0-8.3-3.3-15.8-8.6-21.3c-4.4,6-6.9,13.4-6.9,21.3C95.5,241.3,98,248.7,102.4,254.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000150064085731402246060000006395437283489691035_)",
      fill: "#242F64"
    },
    d: "M110,204.2 c-2.9,2.2-5.5,4.8-7.7,7.8c5.3,5.6,8.6,13.1,8.6,21.3c0,8.3-3.3,15.8-8.6,21.3c2.2,3,4.7,5.6,7.7,7.8c7.3-7.5,11.8-17.8,11.8-29.1 C121.9,222,117.4,211.8,110,204.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000150064085731402246060000006395437283489691035_)",
      fill: "#242F64"
    },
    d: "M161.2,254.7 c-5.3-5.6-8.6-13.1-8.6-21.3c0-8.3,3.3-15.8,8.6-21.3c-2.1-3-4.7-5.6-7.7-7.8c-7.3,7.5-11.8,17.8-11.8,29.1 c0,11.3,4.5,21.6,11.8,29.1C156.5,260.3,159.1,257.7,161.2,254.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000150064085731402246060000006395437283489691035_)",
      fill: "none",
      stroke: "#8DB6E1",
      strokeWidth: 10.92,
      strokeMiterlimit: 10
    },
    d: " M351.1,234.3c-34.3,38.9-86.9,48.7-117.3,21.8c-30.4-26.9-27.3-80.2,7.1-119.1c34.3-38.9,86.9-48.7,117.3-21.8 C388.6,142.1,385.5,195.4,351.1,234.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000150064085731402246060000006395437283489691035_)",
      fill: "#0656A5"
    },
    d: "M846.8,624.3 c-34.5,12.5-68.1,10.1-74.8,9.5c-6.7-0.9-40-6-70.9-25.8c-6.4-4.1-14.8-0.1-15.7,7.5l-8.6,76.8c-5.4,48.2,28.7,91.7,76.4,98.4l0,0 c0.4,0,0.8,0.1,1.2,0.1c0.4,0.1,0.8,0.1,1.2,0.2l0,0c48,4.1,90.8-30.9,96.2-79.1l8.6-76.8C861.3,627.5,853.9,621.7,846.8,624.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000150064085731402246060000006395437283489691035_)",
      fill: "none",
      stroke: "#242F64",
      strokeWidth: 6.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M783.8,687.1c1.1-9.9,10-17.1,20-15.9c9.9,1.1,17.1,10,16,20 M714.8,679.4c1.1-9.9,10-17.1,20-15.9c9.9,1.1,17.1,10,16,20  M806.9,729.3c-9.8,15.2-27.7,24.3-46.9,22.2c-19.3-2.2-34.7-15.1-40.9-32.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000150064085731402246060000006395437283489691035_)",
      fill: "#8DB6E1"
    },
    d: "M737.7,647.8 c-30,21.1-63.1,27.7-69.7,28.8c-6.7,0.9-40.2,4.7-75.2-6.3c-7.2-2.3-14.3,3.8-13.2,11.3l11.9,76.3c7.5,47.9,51.7,81,99.6,74.9l0,0 c0.4-0.1,0.8-0.1,1.2-0.2c0.4-0.1,0.8-0.1,1.2-0.2l0,0c47.4-8.7,79.6-53.6,72.1-101.6l-11.9-76.3 C752.6,647.1,743.9,643.5,737.7,647.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000150064085731402246060000006395437283489691035_)",
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 6.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M693.5,725c-1.5-9.9,5.2-19.1,15.1-20.6c9.9-1.5,19.1,5.2,20.6,15.1 M624.9,735.7c-1.5-9.9,5.2-19.1,15.1-20.6 c9.9-1.5,19.1,5.2,20.6,15.1 M726.8,759.7c-5.5,17.2-20.3,30.8-39.4,33.7c-19.2,3-37.5-5.5-47.9-20.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000150064085731402246060000006395437283489691035_)",
      fill: "#FFFFFF"
    },
    d: "M447.9,1080 c-41.5-71.7-119.1-120-207.9-120c-88.8,0-166.4,48.3-207.9,120H447.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000150064085731402246060000006395437283489691035_)",
      fill: "#F79A6F"
    },
    d: "M927.9,1080 c-41.5-71.7-119.1-120-207.9-120c-88.8,0-166.4,48.3-207.9,120H927.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidelogo);
export default __webpack_public_path__ + "static/media/sidelogo.7681479451010eff997708b71239abe1.svg";
export { ForwardRef as ReactComponent };